import { routers } from "../../Constants/routers";
import { authentication } from "../../Server/Api";

export const eventsName = {
	connectionStatus: "connection-status",
	newIncomingMessage: "new-incoming-message",
};


const base = window.location.hostname === "www.evokeeclinic.com" ? "wss://evokeeclinic.herokuapp.com" : "ws://172.20.10.4:8000" ;


export class AppSocket {
	constructor(props) {
		if (!authentication?.access) window.location = routers.auth.login;
		this.props = props;
		this.socket = new WebSocket(
			`${base}/ws/chats/${props?.id}?token=${authentication?.access}`,
		);
		this.socket.onmessage = (data) => this.onmessage(data);
		this.socket.onopen = () => {
			this.sendMessage({
				"message": "connected",
				"connection": props.id,
				"username": props.self,
			});
		};

		this.socket.onclose = props.setEvents({
			name: eventsName.connectionStatus,
			props: { username: props.other, obj: { is_active: false } },
		});
	}

	get = () => {
		return this;
	};

	sendMessage = (msg) => {
		this.socket.send(JSON.stringify({ message: msg }));
	};

	onmessage = (e) => {

        const data = JSON.parse(e?.data || "")?.message
        if(data?.message === "connected"){
            this.sendMessage({
				"message": "is-online",
				"connection": data.connection,
				"username": data.username,
			})
            this.props.setEvents({
                name: eventsName.connectionStatus,
                props: { username: `${data.connection}`.replace(data.username+"-",""), obj: { is_active: true } },
            });
        }
        else if(data?.message === "is-online"){
            this.props.setEvents({
                name: eventsName.connectionStatus,
                props: { username: data.username, obj: { is_active: true } },
            });
        }
        else{

            this.props.setEvents({
                name: eventsName.newIncomingMessage,
                props: data,
            });
        }
        console.log(e)
	};
}
